/* eslint-disable no-console */
import { useSelector } from "react-redux";

import UserChatBubble from "../../Forms/FirmUserBtn";

import MessageBubble from "./MessageBubble";

const MessageGroup = ({ group, currentUserId }) => {
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  return (
    <div className="m-t-5" style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      {group.map((message, index) => {
        console.log(message);
        const isOwn = message.sender?.id === Number(currentUserId);
        return (
          <div
            key={message.id || message.client_message_id}
            style={{
              display: "flex",
              justifyContent: isOwn ? "flex-end" : "flex-start",
              padding: isOwn ? "0px 0px" : "0 0px",
              gap: "5px",
              alignItems: "center",
            }}
          >
            {/* Avatar for non-own messages */}
            {!isOwn && (
              <UserChatBubble
                data={message}
                first_name={message.sender?.first_name ?? ""}
                last_name={message.sender?.last_name ?? ""}
                profilePic={message.sender?.avatar_url ?? ""}
                is_active={message.sender?.is_active}
                width={19}
                height={25}
                hideIcon={true}
                equalizeNameWidths={false}
                nameClassName="chat-conversation-sender-name"
                isActive={userOnlineStatus?.[message?.sender?.id]?.isOnline ?? false}
              />
              // <div
              //   style={{
              //     width: "19px",
              //     height: "19px",
              //     borderRadius: "50%",
              //     // backgroundColor: "#e2e8f0",
              //     display: "flex",
              //     alignItems: "center",
              //     justifyContent: "center",
              //     color: "#64748b",
              //     fontWeight: "600",
              //     fontSize: "14px",
              //     marginRight: "0px",
              //     flexShrink: 0,
              //     alignSelf: "center",
              //   }}
              // >
              //   <img
              //     src={message.sender?.avatar_url || avatarImg}
              //     alt="avatar"
              //     style={{
              //       width: "19px",
              //       height: "19px",
              //       borderRadius: "50%",
              //       background: "white",
              //     }}
              //   />
              // </div>
            )}

            {/* {!isOwn && (
              <div
                style={{
                  fontSize: "14px",
                  color: "#64748b",
                  // marginBottom: "4px",
                  // marginLeft: "5px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  alignSelf: "center",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                }}
              >
                {message.sender?.first_name} {message.sender?.last_name}
              </div>
            )} */}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: isOwn ? "flex-end" : "flex-start",
                width: "100%",
                maxWidth: "75%",
                minWidth: 0,
                gap: "5px",
              }}
            >
              {/* Sender name only for other users */}

              <MessageBubble
                message={message}
                isOwn={isOwn}
                isFirstInGroup={index === 0}
                isLastInGroup={index === group.length - 1}
                showTimestamp={index === group.length - 1}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MessageGroup;
